export default "/images/833473b0c476218da024bc544c491f36.avif";